import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {ButtonBuiltInControl} from '../ButtonBuiltInControl';

export abstract class ButtonFontFamilyBuiltInControl extends ButtonBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.BLOCK_BUTTON].FONT_FAMILY;
  }
}
